import React from "react";

const BlogFaqList = ({ faqId, question, answer }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`flush-heading${faqId}`}>
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#flush-collapse${faqId}`}
          aria-expanded="false"
          aria-controls={`flush-collapse${faqId}`}
        >
          {question}
        </button>
      </h2>
      <div
        id={`flush-collapse${faqId}`}
        className="accordion-collapse collapse"
        aria-labelledby={`flush-heading${faqId}`}
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default BlogFaqList;
